var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55213 1.32031C2.66378 1.32031 1.125 2.8591 1.125 4.74745C1.125 6.6358 2.66378 8.17458 4.55213 8.17458C6.44048 8.17458 7.97927 6.6358 7.97927 4.74745C7.97927 2.8591 6.44048 1.32031 4.55213 1.32031ZM6.04294 5.97093C5.99496 6.05318 5.90928 6.09774 5.82017 6.09774C5.77562 6.09774 5.73107 6.08746 5.68994 6.06004L4.62753 5.42602C4.36364 5.26837 4.16829 4.92223 4.16829 4.61721V3.21209C4.16829 3.07158 4.28482 2.95506 4.42533 2.95506C4.56584 2.95506 4.68236 3.07158 4.68236 3.21209V4.61721C4.68236 4.74059 4.78518 4.92223 4.89142 4.98392L5.95383 5.61794C6.07721 5.68991 6.11833 5.84756 6.04294 5.97093Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.adf320d2cdc43ab32ffcfc8210fad6b6.svg";
export { ForwardRef as ReactComponent };